module.exports = __webpack_public_path__ + "img/articleAuTravail.9aad3a5c.png";